
(function(app) {
    app.smoothscroll = (function() {
        var initialized = false;


        var classes = {
            navItem: 'go-href',

        };


        var selectors = {
            header  :  '.page-header',
            navItem :  '.go-href'
        };

        var defaults = {
            smooth: 700
        };

        var vars = {
            sectionLink : '',
            positionTop : ''
        }


        var init = function() {
            initialized = true;

            app.$objs.navItem = $(selectors.navItem);

            bind();
        };


        var bind = function() {

            app.$objs.navItem.on('click', function(e) {
               findPositionTop(e,this);
               goHref(vars.positionTop);

               if(app.windowSize() < 420) {
                   app.mobilemenu.closeMenu();
               }

            });
        };

        var width = function() {
            var windowLength = $(window).width();
            return windowLength;
        }


        var findPositionTop = function (e , el) {
            e.preventDefault();

            vars.sectionLink  = $(el).attr('href');

            var hasLink = $(vars.sectionLink).length;

            

            if(hasLink > 0) {
                var status = $('.image-nav-section').hasClass('is-fixed');
                if(status == true) {
                    if(width() >= 1024) {
                        vars.positionTop  = $(vars.sectionLink).offset().top - 160;
                    } else {
                        vars.positionTop  = $(vars.sectionLink).offset().top - 100;
                    }
                }
                else {
                    if(width() >= 1024) {
                        vars.positionTop  = $(vars.sectionLink).offset().top - 320;
                    } else {
                        vars.positionTop  = $(vars.sectionLink).offset().top - 200;
                    }                    
                } 
            }

        };


        var goHref = function (scrollTop) {
            $('html, body').stop().animate({
                'scrollTop': scrollTop
            }, defaults.smooth);
        };

        var isInitialized = function() {
            return initialized;
        };

        return {
            init:          init,
            isInitialized: isInitialized
        };
    })();

    app.registerInit('smoothscroll');
})(pc);
